import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { HomeTabRoute } from '../components/HomeContents/HomeContents';

export const useLogTabNavigation = (routes: HomeTabRoute[]) => {
  const logClickUpperTab = useCallback(
    (prevIndex: number, nextIndex: number) => {
      const prevRoute = routes[prevIndex];
      const nextRoute = routes[nextIndex];
      if (!prevRoute || !nextRoute || prevIndex === nextIndex) return;

      bridge.logAnalyticsEvent({
        name: 'CLICK_UPPER_TAB',
        analytics: {
          SCREEN: prevRoute.screen_name,
          CURRENT_SCREEN_NAME: prevRoute.screen_name,
          NEXT_SCREEN_NAME: nextRoute.screen_name,
          LIST_INDEX: nextIndex,
          LABEL: nextRoute.name,
        },
      });
    },
    [routes],
  );

  const logSwipeTabNavigation = useCallback(
    (prevIndex: number, nextIndex: number) => {
      const prevRoute = routes[prevIndex];
      const nextRoute = routes[nextIndex];
      if (!prevRoute || !nextRoute || prevIndex === nextIndex) return;

      bridge.logAnalyticsEvent({
        name: 'SWIPE_TAB_NAVIGATION',
        analytics: {
          SCREEN: prevRoute.screen_name,
          CURRENT_SCREEN_NAME: prevRoute.screen_name,
          NEXT_SCREEN_NAME: nextRoute.screen_name,
          PREV_INDEX: prevIndex,
          NEXT_INDEX: nextIndex,
          PREV_LABEL: prevRoute.name,
          NEXT_LABEL: nextRoute.name,
          POSITION: 'UPPER_TAB',
        },
      });
    },
    [routes],
  );

  return { logClickUpperTab, logSwipeTabNavigation };
};
